import { __rest } from "tslib";
import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import {
 *   Button,
 *   Input,
 *   Label,
 *   Popover,
 *   PopoverContent,
 *   PopoverTrigger,
 * } from "@skve/components"
 *
 * function Demo() {
 *   return (
 *     <Popover>
 *       <PopoverTrigger asChild>
 *         <Button variant="outline">Open popover</Button>
 *       </PopoverTrigger>
 *       <PopoverContent className="w-80">
 *         <div className="grid gap-4">
 *           <div className="space-y-2">
 *             <h4 className="font-medium leading-none">Dimensions</h4>
 *             <p className="text-sm text-muted-foreground">
 *               Set the dimensions for the layer.
 *             </p>
 *           </div>
 *           <div className="grid gap-2">
 *             <div className="grid grid-cols-3 items-center gap-4">
 *               <Label htmlFor="width">Width</Label>
 *               <Input
 *                 id="width"
 *                 defaultValue="100%"
 *                 className="col-span-2 h-8"
 *               />
 *             </div>
 *             <div className="grid grid-cols-3 items-center gap-4">
 *               <Label htmlFor="maxWidth">Max. width</Label>
 *               <Input
 *                 id="maxWidth"
 *                 defaultValue="300px"
 *                 className="col-span-2 h-8"
 *               />
 *             </div>
 *             <div className="grid grid-cols-3 items-center gap-4">
 *               <Label htmlFor="height">Height</Label>
 *               <Input
 *                 id="height"
 *                 defaultValue="25px"
 *                 className="col-span-2 h-8"
 *               />
 *             </div>
 *             <div className="grid grid-cols-3 items-center gap-4">
 *               <Label htmlFor="maxHeight">Max. height</Label>
 *               <Input
 *                 id="maxHeight"
 *                 defaultValue="none"
 *                 className="col-span-2 h-8"
 *               />
 *             </div>
 *           </div>
 *         </div>
 *       </PopoverContent>
 *     </Popover>
 *   )
 * }
 * ```
 */
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverContent = React.forwardRef((_a, ref) => {
    var { className, align = "center", sideOffset = 4 } = _a, props = __rest(_a, ["className", "align", "sideOffset"]);
    return (React.createElement(PopoverPrimitive.Portal, null,
        React.createElement(PopoverPrimitive.Content, Object.assign({ ref: ref, align: align, sideOffset: sideOffset, className: cn("z-[500] w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className) }, props))));
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
//# sourceMappingURL=popover.js.map